import http from './http';

export default {
  all() {
    return http().get(`/v1/fix_and_flip_selling_infos`);
  },
  get(id) {
    return http().get(`/v1/fix_and_flip_selling_infos/${id}`);
  },
  create(data) {
    return http().post(`/v1/fix_and_flip_selling_infos`, data);
  },
  update(data) {
    return http().put(`/v1/fix_and_flip_selling_infos/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/fix_and_flip_selling_infos/${id}`);
  },
}
